// extracted by mini-css-extract-plugin
module.exports = {"container":"RecordAction_container__2VXjR"};